import { z } from "zod";

export enum EZendeskTicketPriority {
  LOW = "LOW",
  NORMAL = "NORMAL",
  HIGH = "HIGH",
  URGENT = "URGENT",
}

export enum EZendeskTicketStatus {
  NEW = "NEW",
  OPEN = "OPEN",
  PENDING = "PENDING",
  HOLD = "HOLD",
  SOLVED = "SOLVED",
  CLOSED = "CLOSED",
  UNKNOWN = "UNKNOWN",
}

export const zendeskTicketPriorityDtoSchema = z.nativeEnum(EZendeskTicketPriority);

export const zendeskTicketStatusDtoSchema = z.nativeEnum(EZendeskTicketStatus);

export const zendeskTicketAssigneeDtoSchema = z.object({
  email: z.string().nullable(),
  id: z.number().nullable(),
  name: z.string().nullable(),
  tags: z.array(z.string()),
});

export const zendeskTicketGroupDtoSchema = z.object({
  description: z.string().nullable(),
  id: z.number().nullable(),
  name: z.string().nullable(),
});

export const zendeskTicketDtoSchema = z.object({
  assignee: zendeskTicketAssigneeDtoSchema.nullable(),
  createdAt: z.string().pipe(z.coerce.date()),
  description: z.string().nullable(),
  externalId: z.any().nullable(),
  group: zendeskTicketGroupDtoSchema.nullable(),
  id: z.number(),
  priority: zendeskTicketPriorityDtoSchema.default(EZendeskTicketPriority.NORMAL),
  rawSubject: z.string().nullable(),
  recipient: z.string().nullable(),
  status: zendeskTicketStatusDtoSchema.default(EZendeskTicketStatus.UNKNOWN),
  subject: z.string().nullable(),
  tags: z.array(z.string()),
  updatedAt: z.string().pipe(z.coerce.date()),
  url: z.string(),
});

// @ts-expect-error z.object will return any as type for now, it'll be caught in z.infer later
export const zendeskTicketTreeSchemaDto = z.object({
  data: zendeskTicketDtoSchema,
  children: z.lazy<z.ZodArray<z.infer<typeof zendeskTicketTreeSchemaDto>>>(() => zendeskTicketTreeSchemaDto.array()),
});

export type TZendeskTicketPriorityDto = z.infer<typeof zendeskTicketPriorityDtoSchema>;
export type TZendeskTicketStatusDto = z.infer<typeof zendeskTicketStatusDtoSchema>;
export type TZendeskTicketAssigneeDto = z.infer<typeof zendeskTicketAssigneeDtoSchema>;
export type TZendeskTicketGroupDto = z.infer<typeof zendeskTicketGroupDtoSchema>;
export type TZendeskTicketDto = z.infer<typeof zendeskTicketDtoSchema>;
export type TZendeskTicketTreeSchema = z.infer<typeof zendeskTicketTreeSchemaDto>;
